import axios from 'axios';
export * from './user.service';

let accessToken;
accessToken = localStorage.getItem('accessToken');
axios.defaults.headers.common['accessToken'] = `${accessToken}`;
// axios.defaults.headers.common['Authorization'] = `${'Basic ZGVtbzpkZW1v='}`;
axios.defaults.headers.common['Authorization'] = `${'Basic ZGFuY2VfcGFydHk6ZGFuY2VfcGFydHk='}`;
axios.defaults.headers.common['Content-Type'] = `${'application/json'}`;
